import { render, staticRenderFns } from "./details-top-section.vue?vue&type=template&id=0d6f8313"
import script from "./details-top-section.vue?vue&type=script&lang=js"
export * from "./details-top-section.vue?vue&type=script&lang=js"
import style0 from "./details-top-section.vue?vue&type=style&index=0&id=0d6f8313&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports